<template>
  <v-btn color="green" outlined @click="onExport">Xuất excel</v-btn>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import utils from '@/plugins/utils'
import {get, orderBy} from 'lodash'

const headerExcel = [
  {text: 'Mã HS', value: 'code'},
  {text: 'Tên thí sinh', value: 'name'},
  {text: 'Slot', value: 'slot'},
]

export default {
  computed: {
    ...mapGetters({
      event: 'events/getItem',
      eventSlots: 'eventSlots/getItems',
    }),
  },
  methods: {
    ...mapActions({
      fetchAll: 'eventSlotStudents/fetchAll',
    }),
    async onExport() {
      try {
        this.$loading.active = true
        const rawList = await this.fetchAll()
        if (Array.isArray(rawList) && rawList.length) {
          const data = orderBy(rawList, item => get(item, 'eventSlot.index')).map(item => ({
            name: get(item, 'cv.name', ''),
            code: get(item, 'cv.code', ''),
            slot: get(item, 'eventSlot.title', ''),
          }))
          utils.newExportExcel(data, headerExcel, `Danh sách học sinh tham gia sự kiện "${this.event.title}"`)
        }
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
